import '@ionic/react/css/ionic-swiper.css';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Swiper, SwiperSlide } from 'swiper/react';
// swiper bundle styles
import 'swiper/swiper-bundle.min.css';
// swiper core styles
import 'swiper/swiper.min.css';
import { Folder } from '../../models/Folder';
import DAService from '../../services/DAService.service';
import LocalStorage from '../../utils/LocalStorage';
import SearchBar from '../SearchBar';
import './Topics.scss';

export default function Topics(props: {
  screenSize: number;
}) {
  const { screenSize } = props;
  const [slidesPerView, setSlidesPerView] = useState<number>(0);
  const history = useHistory();
  let trueIndex = 0;

  useEffect(() => {
    // handle slidesPerView
    if (screenSize < 600) {
      setSlidesPerView(4.5);
    } else if (screenSize < 900) {
      setSlidesPerView(5);
    } else {
      setSlidesPerView(7);
    }
  }, [screenSize]);

  const handleNavigation = (folderItemId: string, itemId: string, topicPageIndex: number) => () => {
    if (topicPageIndex > 4) {
      history.push(`/goals/${itemId}/`);
    } else {
      history.push(`/topics/${folderItemId}/${itemId}`);
    }
    // update local storage topic index
    LocalStorage.set('topicIndex', topicPageIndex);
  };

  return (
    <>
      <SearchBar data={{ name: '' }} hasNavigation={false} />
      <div className="header-topic">
        Browse By Topic
      </div>
      <Swiper
        className="swiper-topic"
        slidesPerView={slidesPerView}
        observeParents
        observer
      >
        {
          DAService.getFolders().map((folder: Folder) => (
            folder.folderItems && folder.folderItems.map((topic) => {
              trueIndex += 1;
              return (
                <SwiperSlide key={`slider-${topic.itemId}`} onClick={handleNavigation(folder.itemId, topic.itemId, trueIndex)}>
                  <div className="topic-icon-container">
                    <div className="topic-icon-style">
                      <div className="topic-name">
                        {/* eslint-disable-next-line */}
                        {topic.name.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '')}
                      </div>
                    </div>
                    <div className="name-phase-container">
                      <div className="name-phase">
                        {topic.name}
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })
          ))
        }
      </Swiper>
    </>
  );
}
